<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item v-for="item in searchList" :key="item.props" :label="item.label">
							<el-input
								v-if="item.type === 'input'"
								v-model="searchCondition[item.props]"
								:placeholder="'请输入' + item.label"
								clearable
							></el-input>
							<el-select
								v-if="item.type === 'select'"
								v-model="searchCondition[item.props]"
								:placeholder="'请选择' + item.label"
								clearable
							>
								<el-option v-for="option in item.selectData" :key="option.value" :label="option.label" :value="option.value"></el-option>
							</el-select>
							<DatePicker v-if="item.type === 'date'" @dataSearch="dataSearch(item.props, $event)" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
							<el-button type="primary" @click="goCreate">发布课程</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
					<el-table-column label="首页推荐" width="100" align="center">
						<template slot-scope="scope">
							<el-switch
								:value="scope.row.is_recommend == 1"
								@change="changeRecommend(scope.row)"
							></el-switch>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="260" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button v-if="scope.row.upStatus == 0 && scope.row.status != 2" type="text" size="mini" @click="changeOnOff(scope.row, 1)">上架</el-button>
							<el-button v-if="scope.row.upStatus == 1 && scope.row.status != 2" type="text" size="mini" @click="changeOnOff(scope.row, 2)">下架</el-button>
							<el-button v-if="scope.row.upStatus == 2 && scope.row.status != 2" type="text" size="mini" @click="changeOnOff(scope.row, 1)">重新上架</el-button>
							<el-button v-if="scope.row.status != 2" type="text" size="mini" @click="goEdit(scope.row)">编辑</el-button>
							<el-button type="text" size="mini" @click="goDetail(scope.row)">详情</el-button>
							<!-- <el-button v-if="scope.row.status != 2" type="text" size="mini" @click="openSync(scope.row)">同步</el-button> -->
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>

		<!-- <el-dialog title="同步至其他平台" :visible.sync="syncVisible" width="420px">
			<el-form :model="syncForm" label-width="90px">
				<el-form-item label="课程名称">
					<el-input v-model="syncForm.title" disabled></el-input>
				</el-form-item>
				<el-form-item label="小程序位置">
					<el-select v-model="syncForm.publish_list" multiple placeholder="请选择小程序位置" clearable>
						<el-option
							v-for="item in publishTypeList"
							:key="item.value"
							:label="item.label"
							:value="item.value"
							:disabled="syncDisabledList.includes(item.value)"
						></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="syncVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmSync">确 定</el-button>
			</span>
		</el-dialog> -->
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'
import { search_list, tableColumns } from './config/courseRelease.ts'

export default {
	name: 'CourseRelease',
	components: {
		PageHeaderLayout,
		ApeTable,
		DatePicker
	},
	data() {
		return {
			searchCondition: {},
			publishTypeList: [],
			loadingStaus: true,
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			columns: tableColumns.filter(item => item.value !== 'is_recommend_text'),
			syncVisible: false,
			syncDisabledList: [],
			syncForm: {
				id: '',
				title: '',
				publish_list: []
			}
		}
	},
	computed: {
		searchList() {
			return search_list(this.publishTypeList)
		}
	},
	methods: {
		dataSearch(prop, value) {
			this.searchCondition[prop] = value
		},
		searchButton() {
			this.initList('search')
		},
		switchPaging() {
			this.initList()
		},
		getSearchParams() {
			const params = { ...this.searchCondition }
			if (params.date && params.date.length) {
				params.startTime = params.date[0]
				params.endTime = params.date[1]
				delete params.date
			}
			return params
		},
		formatList(list) {
			const statusMap = { 0: '未开始', 1: '进行中', 2: '已结束' }
			return list.map(item => ({
				...item,
				is_recommend_text: item.is_recommend == 1 ? '是' : '否',
				status_text: statusMap[item.status] || '-',
				course_time_text: [item.startTime, item.endTime].filter(Boolean).join(' 至 ')
			}))
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs.apeTable.getPagingInfo(type)
			if (type === 'search') {
				pagingInfo.current_page = 1
			}
			try {
				const res = await this.$api.getCourseList({
					...this.getSearchParams(),
					...pagingInfo
				})
				const list = res.data || res.list || []
				const pages = res.pages || { total: res.total || 0, offset: res.offset || 0 }
				this.tableData = this.formatList(list)
				this.pagingData.total = pages.total || 0
				this.pagingData.offset = pages.offset || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取课程列表失败')
			}
			this.loadingStaus = false
		},
		goCreate() {
			this.$router.push({ path: '/manager/courseCreate' })
		},
		goEdit(row) {
			this.$router.push({ path: '/manager/courseCreate', query: { id: row.id } })
		},
		goDetail(row) {
			this.$router.push({ path: '/manager/courseCreate', query: { id: row.id, flag: true, disabled: true } })
		},
		async changeOnOff(row, upStatus) {
			try {
				await this.$api.courseOnOff(row.id, { upStatus })
				this.$message.success('操作成功')
				this.initList()
			} catch (e) {
				this.$message.error(e.message || '操作失败')
			}
		},
		async changeRecommend(row) {
			try {
				await this.$api.updateCourse(row.id, {
					isRecommend: row.is_recommend == 1 ? 2 : 1
				})
				this.$message.success('修改成功')
				this.initList()
			} catch (e) {
				this.$message.error(e.message || '修改失败')
				this.initList()
			}
		},
		async openSync(row) {
			this.syncForm = {
				id: row.id,
				title: row.title,
				publish_list: []
			}
			this.syncVisible = true
			try {
				const res = await this.$api.getCoursePosition({ id: row.id })
				this.syncDisabledList = res.publish_list || []
			} catch (e) {
				this.syncDisabledList = []
			}
		},
		async confirmSync() {
			if (!this.syncForm.publish_list.length) {
				this.$message.warning('请选择小程序位置')
				return
			}
			try {
				await this.$api.syncCourse({
					id: this.syncForm.id,
					publishType: this.syncForm.publish_list
				})
				this.$message.success('同步成功')
				this.syncVisible = false
				this.initList()
			} catch (e) {
				this.$message.error(e.message || '同步失败')
			}
		},
		async getCoursePublishPos() {
			try {
				const res = await this.$api.getCoursePublishPos()
				this.publishTypeList = (res || []).map(item => ({
					label: item.publish_name,
					value: item.publish_type
				}))
			} catch (e) {
				this.publishTypeList = []
			}
		}
	},
	mounted() {
		this.getCoursePublishPos()
		this.initList()
	}
}
</script>

<style lang="scss" scoped>
.table-search {
	margin-bottom: 16px;
}
</style>
